export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-regular-4f862c8ba4ed785461ee30cf79232437.svg";